import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type AjaxFetchService from 'garaje/services/ajax-fetch';

export default class HrisDashboardDashboardRoute extends Route {
  @service declare ajaxFetch: AjaxFetchService;

  controllerName = 'location-overview/hris-dashboard/dashboard';
  templateName = 'location-overview/hris-dashboard/dashboard';

  async model(): Promise<{ stats: unknown; integrations: unknown }> {
    const [stats, integrations] = await Promise.all([
      this.ajaxFetch.request('/api/v1/hris/stats'),
      this.ajaxFetch.request('/api/v1/hris/integrations'),
    ]);
    return { stats, integrations };
  }
}
